/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ balance: NonNullable<unknown> }} Seo_Endpoint_A_FreeInputs */

const en_seo_endpoint_a_free = /** @type {(inputs: Seo_Endpoint_A_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yes. A new AnyAPI account starts with ${i?.balance} of free balance and no card required.`)
};

const zh_hans1_seo_endpoint_a_free = /** @type {(inputs: Seo_Endpoint_A_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`可以。新的 AnyAPI 账户自带 ${i?.balance} 免费余额，无需绑卡。`)
};

const pt_br2_seo_endpoint_a_free = /** @type {(inputs: Seo_Endpoint_A_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sim. Uma conta nova da AnyAPI começa com ${i?.balance} de saldo grátis, sem cartão.`)
};

const es_seo_endpoint_a_free = /** @type {(inputs: Seo_Endpoint_A_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sí. Una cuenta nueva de AnyAPI empieza con ${i?.balance} de saldo gratis, sin tarjeta.`)
};

const fr_seo_endpoint_a_free = /** @type {(inputs: Seo_Endpoint_A_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oui. Un nouveau compte AnyAPI démarre avec ${i?.balance} de solde gratuit, sans carte.`)
};

const de_seo_endpoint_a_free = /** @type {(inputs: Seo_Endpoint_A_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ja. Ein neues AnyAPI-Konto startet mit ${i?.balance} Gratis-Guthaben, ohne Karte.`)
};

const ru_seo_endpoint_a_free = /** @type {(inputs: Seo_Endpoint_A_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Да. Новый аккаунт AnyAPI стартует с бесплатным балансом ${i?.balance}, карта не нужна.`)
};

const it_seo_endpoint_a_free = /** @type {(inputs: Seo_Endpoint_A_FreeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sì. Un nuovo account AnyAPI parte con ${i?.balance} di saldo gratuito e senza bisogno di carta.`)
};

/**
* | output |
* | --- |
* | "Yes. A new AnyAPI account starts with {balance} of free balance and no card required." |
*
* @param {Seo_Endpoint_A_FreeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_a_free = /** @type {((inputs: Seo_Endpoint_A_FreeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_A_FreeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_a_free(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_a_free(inputs)
	if (locale === "es") return es_seo_endpoint_a_free(inputs)
	if (locale === "fr") return fr_seo_endpoint_a_free(inputs)
	if (locale === "de") return de_seo_endpoint_a_free(inputs)
	if (locale === "ru") return ru_seo_endpoint_a_free(inputs)
	if (locale === "it") return it_seo_endpoint_a_free(inputs)
	return en_seo_endpoint_a_free(inputs)
});